import { lazy } from 'react';
import { Route } from 'react-router-dom';
import { key } from './config';

const List = lazy(() => import('./index'));
const Batch = lazy(() => import('./batch'));

export default function OwnConsumptionRoutes() {
  return (
    <Route path={key}>
      <Route index element={<List />} />
      <Route path="batch" element={<Batch />} />
    </Route>
  );
}
